// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export function oxxoOutgoingPaymentMapper(): $Shape<OutgoingPayment> {

  return {
    payment_type: 'oxxo',
    payment_type_code: 'oxxo',
    instalments: '1',
  };
}
